import React, { useMemo } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import type { EventClickArg } from "@fullcalendar/core";
import type { BannerSwap } from "../../../utils/@types";
import { swapsToCalendarEvents } from "../bannerCalendarUtils";
import "../bannerSwapCalendar.css";

type BannerSwapCalendarProps = {
  swaps: BannerSwap[];
  onEventClick: (swap: BannerSwap) => void;
};

const BannerSwapCalendar: React.FC<BannerSwapCalendarProps> = ({
  swaps,
  onEventClick,
}) => {
  const events = useMemo(() => swapsToCalendarEvents(swaps), [swaps]);

  const handleEventClick = (arg: EventClickArg) => {
    arg.jsEvent.preventDefault();
    const swap = arg.event.extendedProps.swap as BannerSwap | undefined;
    if (swap) {
      onEventClick(swap);
    }
  };

  return (
    <div className="banner-swap-calendar">
      <FullCalendar
        plugins={[dayGridPlugin, interactionPlugin]}
        initialView="dayGridMonth"
        initialDate={new Date()}
        headerToolbar={{
          left: "prev,next today",
          center: "title",
          right: "dayGridMonth,dayGridWeek",
        }}
        height="auto"
        contentHeight="auto"
        expandRows
        dayMaxEvents={4}
        moreLinkClick="popover"
        events={events}
        eventClick={handleEventClick}
        eventDisplay="block"
        nowIndicator
      />
    </div>
  );
};

export default BannerSwapCalendar;
